import { ChangeDetectionStrategy, Component, Input, inject } from '@angular/core';
import { ReportsContext } from '../reports.context';
import _ from 'lodash';
import { ProjectSummaryReportModel } from '../../projects/project-summary/project-summary-report/project-summary-report.model';
import { AsyncPipe } from '@angular/common';
import { CommonModules } from '../../common/common.module';

@Component({
    selector: 'adm4-project-report-generation-output',
    template: `
    <div class="generation-output-container">
      @if (reportsContext.generationOutput$ | async; as html) {
        @if (isSafeHtml(html)) {
          <div [innerHtml]="html"></div>
        } @else {
          <iframe [srcdoc]="html | reportsHtml" class="output-iframe"></iframe>
        }
      }
    
      @if ((reportsContext.isGenerationFailed$ | async) || (reportsContext.isNothingToDo$ | async)) {
        <div class="content failed">
          <p>The report could not be generated.</p>
          @if (reportsContext.isGenerationFailed$ | async) {
            <p>Please check the project for issues.</p>
          }
          @if (reportsContext.isNothingToDo$ | async) {
            <p>Please make sure the project has at least an instance pattern.</p>
          }
        </div>
      }
    </div>
    `,
    styleUrls: ['project-report-generation-output.component.scss'],
    imports: [
        AsyncPipe,
        CommonModules
    ],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class ProjectReportGenerationOutputComponent {
  reportsContext = inject(ReportsContext);


  @Input() report: ProjectSummaryReportModel | null = null;

  isSafeHtml(html: string) {
    return !_.includes(html, '<script');
  }
}
